import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import CloseIcon from "@mui/icons-material/Close";

import NavigationList from "./NavigationList";
import { useTranslation } from "react-i18next";

function Navigation({ setOpen, width }) {
  const { t } = useTranslation();
  return (
    <div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        paddingRight={1}
      >
        <ListItem sx={{ borderRadius: 1 }}>
          <ListItemText>
            <Typography variant="h6">{t("library.title")}</Typography>
          </ListItemText>
        </ListItem>
        <IconButton
          onClick={() => setOpen((prev) => !prev)}
          size="small"
          sx={{ padding: 1 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </Box>
      <NavigationList />
    </div>
  );
}

export default Navigation;
